import { type JSX } from 'react';
import { useAuth } from '../lib/auth-context.tsx';
import { buttonClass } from './ui/index.ts';

/** Shown wherever a screen would otherwise spin forever on a bootstrap that failed on a dropped connection. */
export function BootstrapConnectionError(): JSX.Element {
  const { retryBootstrap } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-4 text-center">
        <h1 className="text-xl font-semibold tracking-tight">Can’t connect to HapMetrix</h1>
        <p className="text-sm text-muted-foreground">
          Check your internet connection. We’ll keep trying.
        </p>
        <button
          type="button"
          onClick={() => retryBootstrap()}
          className={buttonClass('primary')}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
